import { render, staticRenderFns } from "./Rensai.vue?vue&type=template&id=9f3b0896&scoped=true"
import script from "./Rensai.vue?vue&type=script&lang=js"
export * from "./Rensai.vue?vue&type=script&lang=js"
import style0 from "./Rensai.vue?vue&type=style&index=0&id=9f3b0896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3b0896",
  null
  
)

export default component.exports